(function(){
function init(){
var root=document.querySelector('[data-nt-product]');if(!root)return;
var description=root.querySelector('[data-nt-product-panel="description"]'),source=root.querySelector('[data-nt-description-layout]'),rte=description&&description.querySelector('.nt-pdp-tabs__rte');
if(source&&rte&&!description.querySelector('.nt-description-story')){
 // Replace repeated boilerplate with visible feature cards; preserve nonstandard content.
 var extra=document.createElement('section');extra.className='nt-story-extra';
 var standard=/^(Aftermarket Injection Plastic|Strong and durable super ABS|Custom painted as shown|\(?Please note the color|Each piece is packed individually|Correct tabs and pre-drilled|Free Gifts included:|If you want any other color scheme|Why Buy from NT FAIRING|We have \d+ warehouses|Best quality for aftermarket|Product Features:|Package Contain:|Windscreen and Heat Shield|Custom Your Fairings:|Click here(?:$|\s+to see more color options)|to see more color options|We can also produce individual parts|contact us$|\.$)/i;
 var holder=document.createElement('div');holder.innerHTML=rte.innerHTML.replace(/<br\b[^>]*>/gi,'</p><p>');
 Array.from(holder.childNodes).forEach(function(n){
   var text=(n.textContent||'').trim();
   if(!text&&!(n.nodeType===1&&n.querySelector('img,video,iframe')))return;
   if(standard.test(text)&&!(n.nodeType===1&&n.querySelector('img,video,iframe')))return;
   var item=document.createElement('div');item.className='nt-story-extra-item';item.append(n.cloneNode(true));extra.append(item);
 });
 description.insertBefore(source.content.cloneNode(true),rte);
 if(extra.childNodes.length){var h=document.createElement('h3');h.textContent='More about this kit';extra.prepend(h);rte.before(extra);}
 rte.remove();
}
var policy=root.querySelector('.nt-pdp-policy-detail');
if(policy){
 policy.classList.add('nt-policy-open');
 policy.querySelectorAll('.nt-pdp-policy-grid__policy').forEach(function(body){
  var grid=document.createElement('div');grid.className='nt-policy-open-grid';
  var card=null,index=0;
  var icons=['shield','truck','wrench','camera','reply','credit-card','envelope'];
  Array.from(body.children).forEach(function(node){
   if(/^H[2-4]$/.test(node.tagName)){
    card=document.createElement('article');card.className='nt-policy-open-card';
    var icon=document.createElement('i');icon.className='fa fa-'+(icons[index]||'check-circle');icon.setAttribute('aria-hidden','true');
    var heading=document.createElement('h4');heading.textContent=node.textContent;
    card.append(icon,heading);grid.append(card);index++;
   }else if(card){card.append(node);}else{node.classList.add('nt-policy-open-intro');}
  });
  body.querySelectorAll('h2,h3,h4').forEach(function(n){n.remove();});body.append(grid);
 });
}
var grid=root.querySelector('.nt-pdp-policy-grid');
if(grid){grid.classList.add('nt-policy-summary-cards');
 grid.querySelectorAll(':scope > article').forEach(function(card,index){var kicker=card.querySelector(':scope > span');if(kicker){var icon=document.createElement('i');icon.className=index?'fa fa-shield':'fa fa-truck';icon.setAttribute('aria-hidden','true');kicker.prepend(icon);}});
}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();